<template>
    <ModalBox class="ConfigBox" v-model="show">
        <div class="pass-top-text">设置</div>
        <div class="input-note">
            常规对话线路：
            <el-select :value="useLLM" @change="setLLM" :popper-append-to-body="false" popper-class="config-popper">
                <el-option v-for="item in llmList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
        </div>
        <div class="input-note">
            调试模式：
            <el-switch :value="isDebug" @change="toggleDebug"></el-switch>
        </div>
        <div class="input-note">
            夜间模式：
            <el-switch :value="isDark" @change="toggleDark"></el-switch>
        </div>
    </ModalBox>
</template>
<script>
import llmAPI from '@/api/llm.api.js';
import ModalBox from './ModalBox.vue';
export default {
    name: 'ConfigBox',
    components: { ModalBox },
    data () {
        return {
            show: false,
            llmList: []
        };
    },
    computed: {
        isDark () {
            return this.$store.state.appSettings.isDark;
        },
        isDebug () {
            return this.$store.state.appSettings.isDebug;
        },
        useLLM () {
            return this.$store.state.appSettings.useLLM;
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    mounted () {
        this.show = this.visible;
        this.getLLmList();
    },
    watch: {
        visible (val) {
            this.show = val;
        },
        show (val) {
            this.$emit('update:visible', val);
        }
    },
    methods: {
        async getLLmList () {
            let ret = await llmAPI.getLLNList();
            let list = ret.data || [];
            let pciList = [];
            let notPciList = [];
            for (let i = 0, len = list.length; i < len; i++) {
                if ((list[i].toLowerCase()).indexOf('pci') !== -1) {
                    pciList.push(list[i]);
                } else {
                    notPciList.push(list[i]);
                }
            }
            this.llmList = pciList.concat(notPciList);
        },
        toggleDark () {
            this.$store.commit('appSettings/toggleDark');
        },
        toggleDebug () {
            this.$store.commit('appSettings/toggleDebug');
        },
        setLLM (val) {
            this.$store.commit('appSettings/setLLM', val);
            this.$message.success('线路已切换');
        }
    }
};
</script>
<style lang="scss" scoped>
.ConfigBox {
    .pass-top-text {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
        font-weight: 500;
        line-height: 24px;
        margin-bottom: 12px;
    }

    .input-note {
        width: 400px;
        height: 48px;
        margin-bottom: 8px;
        padding: 0 16px;
        text-align: left;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(18, 108, 255, 0.04);
        color: var(--ant-mentions-text);
        .el-select{
            width: 160px;
            ::v-deep{
                .el-input__inner{
                    border: none;
                    background: transparent;
                    text-align: right;
                    color: var(--ant-mentions-text);
                    padding-right: 24px;
                    }
                .el-input__suffix{
                    right: -5px;
                }
                .config-popper{
                    backdrop-filter: blur(10px);
                    transform: translate(84px, -14px);
                    background:var(--ant-mentions-bg);
                    box-shadow: 0px 2px 6px 0px rgba(7,22,51,0.2);
                    border: none;
                    .el-select-dropdown__list{
                        padding: 0 16px;
                    }
                    .el-select-dropdown__item{
                        color: var(--ant-mentions-text);
                        height: 48px;
                        line-height: 48px;
                        text-align: center;
                        border-bottom: 1px solid var(--ant-mentions-border);
                        padding: 0;
                        &.selected,
                        &.hover{
                            color: var(--ant-mentions-text-hover);
                            background: transparent;
                        }
                        &:last-child{
                            border-bottom: 0px solid var(--ant-mentions-border);
                        }
                    }
                    .popper__arrow{
                        display: none;
                    }
    }
            }
        }
        .el-switch{
            width: 32px;
        }
    }
}
</style>
